import { ChartType, } from '../../../../../../types/savedCharts';
export const getPieChartConfig = ({ queryTool, metricQuery, }) => {
    const { dimensions } = queryTool.queryConfig;
    const { metrics } = metricQuery;
    const { chartConfig } = queryTool;
    const config = {
        groupFieldIds: dimensions,
        metricId: (chartConfig?.yAxisMetrics?.[0] || metrics[0]),
    };
    return {
        type: ChartType.PIE,
        config,
    };
};
//# sourceMappingURL=pie.js.map